export const PRODUCT_UID_ATTR = "data-product-gen-uid";
export const PRODUCT_ELEMENT = `[${PRODUCT_UID_ATTR}]`;
export const INJECT_ELEMENT_CLASS = "__CC-inject";
export const INJECT_WRAPPER_ELEMENT = `<div class="${INJECT_ELEMENT_CLASS}"></div>`;
